<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li>
            <!-- <router-link :to="{path:'/dashboard'}">Dashboard</router-link> -->
            <router-link :to="{path:'/products-list'}">Início</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright d-flex flex-wrap">
        Developed by <a href="https://accesys.com.br" target="_blank">&nbsp; Accesys Solutions.</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
